import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import { GiRabbitHead } from "react-icons/gi";
import callOpenAIAPI from "../../utils/openAI";

import ReactMarkdown from "react-markdown"; // For Markdown rendering

const RaboChat = () => {
    const [messages, setMessages] = useState(() => {
        // Load messages from localStorage or start with default message
        const savedMessages = localStorage.getItem("chatMessages");
        return savedMessages
            ? JSON.parse(savedMessages)
            : [{ sender: "bot", text: "Hello I am Rabo! How can I assist you today?" }];
    });
    const [input, setInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Save messages to localStorage whenever they change
        localStorage.setItem("chatMessages", JSON.stringify(messages));
    }, [messages]);

    const handleSendMessage = async () => {
        if (!input.trim()) return;

        const userMessage = { sender: "user", text: input };
        setMessages((prev) => [...prev, userMessage]);
        setInput("");

        setIsLoading(true);

        try {
            // Call the backend API for the `generalChat` use case
            ////////console.log("Sending query to backend:", input);
            const botReply = await callOpenAIAPI("generalChat", { query: input });

            setMessages((prev) => [
                ...prev,
                // userMessage,
                { sender: "bot", text: botReply || "Sorry, I didn't understand that." },
            ]);
        } catch (error) {
            console.error("Error communicating with the backend:", error);
            setMessages((prev) => [
                ...prev,
                // userMessage,
                { sender: "bot", text: "Sorry, something went wrong!" },
            ]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center w-full h-screen pb-[60px] bg-[#FFFFFF]">
            {/* Chat Container */}
            <div className="flex flex-col w-full max-w-3xl h-[90vh] bg-white rounded-lg overflow-hidden">
                {/* Chat Messages */}
                <div className="flex-grow overflow-y-auto p-4 bg-white">
                    {messages.map((message, index) => (
                        <div
                            key={index}
                            className={`flex items-start mb-4 ${
                                message.sender === "user" ? "justify-end" : ""
                            }`}
                        >
                            {/* Display Icon for Bot Messages */}
                            {message.sender !== "user" && (
                                <div className="w-8 h-8 flex items-center justify-center bg-[#EEF0ED] rounded-full mr-3">
                                    <GiRabbitHead className="text-[#3b3b3b] w-6 h-6" />
                                </div>
                            )}

                            {/* Message Content */}
                            <div
                                className={`p-3 ${
                                    message.sender === "user"
                                        ? "bg-[#3b3b3b] text-white self-end ml-auto rounded-full"
                                        : "bg-white text-black"
                                }`}
                                style={
                                    message.sender === "user"
                                        ? {
                                            maxWidth: "70%",
                                            minWidth: "fit-content",
                                            width: "fit-content",
                                            marginLeft: "auto",
                                        }
                                        : {}
                                }
                            >
                                {message.sender === "bot" ? (
                                    <ReactMarkdown>{message.text}</ReactMarkdown> // Markdown rendering
                                ) : (
                                    <span>{message.text}</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Input Box */}
                <div className="p-4 pb-[20px] border-t bg-[#EEF0ED] rounded-full">
                    <div className="flex gap-4 items-center">
                        <input
                            type="text"
                            placeholder="Type your message..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
                            className="flex-grow p-3 text-black bg-[#EEF0ED] focus:outline-none"
                        />
                        <button
                            onClick={handleSendMessage}
                            className="bg-[#3b3b3b] text-white w-10 h-10 flex items-center justify-center rounded-full hover:bg-opacity-70"
                        >
                            <FaArrowUp />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RaboChat;
